import CrossOrgService from '../services/CrossOrgService';
import Common from './common'
import Vue from 'vue'
import _ from 'lodash'

const state = {
    endpoints: {},
    codesets: [],
    typeCodes: [],
    systems: {},
    users: {},
    auditHistory: {},
    datafeed: {},
    appConfigs: {},
    accessGroups: {},
    workerSessions: {},
    reportModules: [],
    activeOrg: {enabledModules:[]},
    activeOrgOriginal: {enabledModules:[]}
}
const getters = {
    getAuditHistory(state) { return state.auditHistory; },
    getDatafeed(state) { return state.datafeed; },
    getEndpoints(state) { return state.endpoints; },
    getAccessGroups(state) { return state.accessGroups; },
    getSystems(state) { return state.systems },
    getAppConfigs(state) { return state.appConfigs },
    getUsers(state) { return state.users },
    getWorkerSessions(state) { return state.workerSessions },
    getReportModules(state) { return state.reportModules },
    activeOrg(state) { return state.activeOrg },
    getCodeSets(state) { return state.codesets },
    getTypeCodes(state) { return state.typeCodes }
}

const mutations = {
    initialize(state) {
        Vue.set(state, 'auditHistory', {})
        Vue.set(state, 'datafeed', {})
        Vue.set(state, 'endpoints', {})
        Vue.set(state, 'systems', [])
        Vue.set(state, 'users', {})
        Vue.set(state, 'appConfigs', {})
        Vue.set(state, 'accessGroups', {})
        Vue.set(state, 'workerSessions', {})
        Vue.set(state, 'reportModules', [])
        Vue.set(state, 'codesets', [])
        Vue.set(state, 'typeCodes', [])
        Vue.set(state, 'activeOrg', {enabledModules:[]})
        Vue.set(state, 'activeOrgOriginal', {enabledModules:[]})
    },
    setReportModules(state, modules) {
        Vue.set(state, 'reportModules', modules)
    },
    setActiveOrg(state, org) {
        Vue.set(state, 'activeOrg', org)
    },
    setActiveOrgOriginal(state, org) {
        Vue.set(state, 'activeOrgOriginal', org)
    }
}

const actions = {
    initialize ({commit}) {
        commit('initialize')
    },
    async getAuditHistory({state, commit, dispatch},{filter, sort, page, size}) {
        let response = await CrossOrgService.getAuditHistory(filter, sort, page, size)
        return response.data
    },
    async getDatafeed({state, commit, dispatch},{filter, sort, page, size}) {
        let response = await CrossOrgService.getDatafeed(filter, sort, page, size)
        return response.data
    },
    async getEndpoints({state, commit, dispatch},{filter, sort, page, size}) {
        let response = await CrossOrgService.getEndpoints(filter, sort, page, size)
        return response.data
    },
    async getUsers({state, commit, dispatch},{filter, sort, page, size}) {
        let response = await CrossOrgService.getUsers(filter, sort, page, size)
        return response.data
    },
    async getSystems({state, commit, dispatch},{filter, sort, page, size}) {
        let response = await CrossOrgService.getSystems(filter, sort, page, size)
        return response.data
    },
    async getIntegrationTokens({state, commit, dispatch}) {
        let response = await CrossOrgService.getIntegrationTokens()
        return response.data
    },
    async getOrgApprovals({state, commit, dispatch}) {
        let response = await CrossOrgService.getOrgApprovals()
        return response.data
    },
    async getAppConfigs({state, commit, dispatch},{filter, sort, page, size}) {
        let response = await CrossOrgService.getAppConfigs(filter, sort, page, size)
        return response.data
    },
    async getAccessGroups({state, commit, dispatch},{filter, sort, page, size}) {
        let response = await CrossOrgService.getAccessGroups(filter, sort, page, size)
        return response.data
    },
    async getCodeSets({state, commit, dispatch}) {
        let response = await CrossOrgService.getCodeSets()
        return response.data
    },    
    async getTypeCodes({state, commit, dispatch},{filter, sort, page, size}) {
        let response = await CrossOrgService.getTypeCodes(filter, sort, page, size)
        return response.data
    },
    async getWorkerSessions({state, commit, dispatch},{filter, sort, page, size}) {
        let response = await CrossOrgService.getWorkerSessions(filter, sort, page, size)
        return response.data
    },
    async updateSystem({}, {system, patchObject, pwd}) {
        try {
            let response = await CrossOrgService.updateSystem(system, patchObject, pwd)
            return true
        } catch (e) {
            return false
        }
    },
    async updateEndpoint({}, {endpoint, patchObject, pwd}) {
        try {
            let response = await CrossOrgService.updateEndpoint(endpoint, patchObject, pwd)
            return true
        } catch (e) {
            return false
        }        
    },
    async upsertTypeCode({}, {typeCode}) {
        try {
            let response = await CrossOrgService.upsertTypeCode(typeCode)
            return true
        } catch (e) {
            return false
        }        
    },
    async updateTypeCode({}, {typeCode, patchObject}) {
        try {
            let response = await CrossOrgService.updateTypeCode(typeCode, patchObject)
            return true
        } catch (e) {
            return false
        }        
    },
    async updateUser({}, {user, patchObject}) {
        try {
            let response = await CrossOrgService.updateUser(user, patchObject)
            return true
        } catch (e) {
            return false
        }        
    },
    async upsertIntegrationToken({}, {integrationToken}) {
        try {
            let response = await CrossOrgService.upsertIntegrationToken(integrationToken)
            return true
        } catch (e) {
            return false
        }        
    },
    async deleteIntegrationToken({}, {integrationToken}) {
        try {
            let response = await CrossOrgService.deleteIntegrationToken(integrationToken)
            return true
        } catch (e) {
            return false
        }        
    },
    async upsertOrgApproval({}, {orgApproval}) {
        try {
            let response = await CrossOrgService.upsertOrgApproval(orgApproval)
            return true
        } catch (e) {
            return false
        }        
    },
    async approveOrg({}, orgApproval) {
        try {
            let response = await CrossOrgService.approveOrg(orgApproval)
            return true
        } catch (e) {
            return false
        }        
    },
    async deleteOrgApproval({}, {orgApproval}) {
        try {
            let response = await CrossOrgService.deleteOrgApproval(orgApproval)
            return true
        } catch (e) {
            return false
        }        
    },    
    async updateOrg({commit}, {org, patchObject}) {
        try {
            let response = await CrossOrgService.updateOrg(org, patchObject)

            commit('setActiveOrg', response.data)
            commit('setActiveOrgOriginal', Common.deepcopy(response.data))

            return response.data
        } catch (e) {
            console.error(e)
            return null
        }        
    },
    async updateConfig({}, {config}) {
        try {
            let response = await CrossOrgService.updateConfig(config)
            return true
        } catch (e) {
            return false
        }        
    },
    async buildModuleURL({}, {userId, orgId, login, module}) {
        let response = await CrossOrgService.getToken(orgId, userId)
        if ((response.status === 200) && (response.data)) {
            let baseUrl = window.location.href.split(/\/?[?#]/)[0]
            return baseUrl + "/#/login/" + response.data + "/" + login + "/url/" + module
        }
        return null
    },
    async getOrganization({commit}, id) {
        try {
            let response = await CrossOrgService.getOrganization(id)
            if (response.data) {
                response.data.enabledModules = response.data.enabledModules || []
            }
            commit('setActiveOrg', response.data)
            commit('setActiveOrgOriginal', Common.deepcopy(response.data))
            return response.data
        } catch (ex) {
            console.error(ex)
            return {}
        }
    },
    async createOrg({dispatch}, orgReqData) {
        let response
        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Adding organization"}, {root: true})
            response = await CrossOrgService.createOrganization(orgReqData)

            if (response && (response.status === 200)) {
                dispatch('status/setStatus', {inProgress: false, operation: "Organization created", success: true, logAction: 'creating-org'}, {root: true})
                return response.data
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error creating organization", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-creating-org'}, {root: true})
                alert(response.data)
                return response.data
            }
        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error creating organization", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-creating-org'}, {root: true})
            alert(Common.getErrorMessage(ex))
            return null
        }
    },
    resetActiveOrg({state, commit}) {
        commit('setActiveOrg', Common.deepcopy(state.activeOrgOriginal))
    },
    async purgeOrg({state, commit}, id) {
        try {
            let response = await CrossOrgService.purgeOrg(id)

            commit('setActiveOrg', response.data)
            commit('setActiveOrgOriginal', Common.deepcopy(response.data))

            return response.data
        } catch (e) {
            console.error(e)
            return null
        }
    },
    async getReportModules({commit}) {
        try {
            let response = await CrossOrgService.getReportModules()
            commit('setReportModules', response.data)
        } catch (ex) {
            console.error(ex)
        }    
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}